module.exports = __webpack_public_path__ + "static/media/Fixed-Cab.e16be557.svg";